import { completeAssuranceByBrand, packagesFor } from "../config/pricing";

// The registration form on ServiceBoss's service history pages and guides. A plain
// GET form, like the prerendered one (serviceHistoryFormHtml in
// scripts/lib/prerender-shell.mjs): checkout reads vrm and plan.
export default function ServiceHistoryRegForm({ brandKey, heading }) {
  const complete = packagesFor(brandKey).find((plan) => plan.key === "complete");
  return (
    <section className="search-card">
      <h2>{heading}</h2>
      <p>Enter a UK registration. Checkout confirms whether service history is available for the car before you pay.</p>
      <form className="search" action="/checkout" method="get">
        <input type="hidden" name="plan" value="complete" />
        <input name="vrm" maxLength="8" autoComplete="off" aria-label="UK registration" placeholder="ENTER REG" required />
        <button type="submit">Check service history</button>
      </form>
      <p className="search-price">{complete.name} £{complete.plate} · one-off payment, no subscription. {completeAssuranceByBrand[brandKey]} <a href="/pricing">See what each check includes</a>.</p>
    </section>
  );
}
